"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createPromotionsEndpointRequest = void 0;
function createPromotionsEndpointRequest(parameters = {}) {
    return {
        method: 'GET',
        endpoint: 'promotions',
        params: Object.assign(Object.assign(Object.assign(Object.assign({}, (parameters.pagination && parameters.pagination.page
            ? { page: parameters.pagination.page }
            : undefined)), (parameters.pagination && parameters.pagination.perPage
            ? { perPage: parameters.pagination.perPage }
            : undefined)), (parameters.ids ? { ids: parameters.ids.join(',') } : undefined)), (parameters.activeAt ? { activeAt: parameters.activeAt } : undefined)),
    };
}
exports.createPromotionsEndpointRequest = createPromotionsEndpointRequest;
